/**
 * Basic fetcher
 */

export const basicFetcher = (url: string, queryParams = '') => fetch(`${url}${queryParams}`).then((res) => res.json());

export const baseFetcher = async ({
    url, 
    queryParams = '', 
    accept = 'application/json', 
    method = 'GET',
    data = '',
    contentType = 'application/json'
}: {
    url: string;
    queryParams?: any;
    accept?: string;
    method?: string;
    data?: any;
    contentType?: string;
}) => {
    
    const headers :any = {
        "accept": accept,
    }

    if(contentType) {
        headers['Content-Type'] = contentType;
    }

    const options: RequestInit = {
        method: method,
        headers: headers,
    };

    if(data) {
        options.body = data
    }
    
    const res = await fetch(
        `${url}${queryParams}`,
        options
    );
    return await res.json();

}



export const fetcher = async ({
    url, 
    headers,
    queryParams = '',  
    method = 'GET',
    data = '',
}: {
    url: string;
    headers: HeadersInit
    queryParams?: string;
    method?: string;
    data?: any;
    
}) => {

    const options: RequestInit = {
        method: method,
        headers: headers,
    };

    if(data) {
        options.body = data
    }

    return fetch(
        `${url}${queryParams}`, 
        options
    ).then(async (res) => {
        if(res.ok) {
            return res.status != 204 ?res.json() : {};
        } else {
            const data = await res?.json();
            console.error(data);
            throw new Error(data.detail || data.title || 'An error occurred');
        }
    });

}


export const apiFetcher = async ({
    route, 
    queryParams = null, 
    accept = 'application/json', 
    method = 'GET',
    data = null,
    contentType = 'application/json',
    clientId = null
}: {
    route: string;
    queryParams?: URLSearchParams;
    accept?: ApiContentType;
    method?: ApiMethod;
    data?: any;
    contentType?: ApiContentType;
    clientId?: number
}) => {

    let bodyData = data;
    if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method.toUpperCase()) && data) {
        bodyData = JSON.stringify(data);
    }

    const headers : HeadersInit = {
        "accept": accept,
        "X-AUTH-TOKEN": ENV.api_backyou.key,
        "MUID": membres_uid,
        "SUID": societes_uid,
        "lang": ENV.lang,
        "Content-Type": contentType
    }

    let url = ENV.api_backyou.url;
    if(clientId) { url += 'clients/'+clientId+'/'; }
    url += route;
    if(queryParams) url+='?'+queryParams;

    return fetcher({
        url: url,
        method,
        headers,
        data: bodyData
    });
};


export const apiFetcherGet = async ({
    route, 
    queryParams, 
    contentType = 'application/json',
    clientId = null
}: {
    route: string;
    queryParams?: URLSearchParams;
    contentType?: ApiContentType,
    clientId?: number
}) => {

    return apiFetcher({
        route: route,
        queryParams: queryParams, 
        accept: contentType,
        contentType: contentType,
        clientId: clientId
    });
};

export const apiFetcherPost = async ({
    route, 
    data,
    clientId = null
}: {
    route: string
    data?: object
    clientId?: number
}) => {
    
    return apiFetcher({
        route: route,
        method: 'POST',
        data: data,
        accept: 'application/json',
        contentType: 'application/json',
        clientId: clientId
    });
};

export const apiFetcherPatch = async ({
    route, 
    data,
    clientId = null
}: {
    route: string
    data?: object
    clientId?: number
}) => {

    return apiFetcher({
        route: route,
        method: 'PATCH',
        data: data,
        accept: 'application/json',
        contentType: 'application/merge-patch+json',
        clientId: clientId
    });
};


export const apiFetcherDelete = async ({
    route,
    clientId = null
}: {
    route: string
    clientId?: number
}) => {

    return apiFetcher({
        route: route,
        method: 'DELETE',
        data: {},
        clientId: clientId
    });
};


export const ajaxFetcher = async ({
    url, 
    queryParams = null, 
    accept = 'application/json', 
    method = 'GET',
    data = null,
    contentType = 'application/json'
}: {
    url: string;
    queryParams?: URLSearchParams;
    accept?: AjaxContentType;
    method?: AjaxMethod;
    data?: any;
    contentType?: AjaxContentType;
}) => {

    const headers : HeadersInit = {
        "accept": accept,
        "Content-Type": contentType
    }

    let fetcherUrl = url;
    if(queryParams) fetcherUrl+='?'+queryParams;


    return fetcher({
        url: fetcherUrl,
        method,
        headers,
        data: data
    });
    
}


export const ajaxFetcherGet = async ({
    url, 
    queryParams
}: {
    url: string;
    queryParams?: URLSearchParams;
}) => {

    return ajaxFetcher({
        method: 'GET',
        url: url,
        queryParams: queryParams
    });
};

export const ajaxFetcherPost = async ({
    url, 
    queryParams,
    contentType = 'application/x-www-form-urlencoded',
    data = null
}: {
    url: string;
    queryParams?: URLSearchParams;
    contentType?: AjaxContentType
    data?: URLSearchParams
}) => {

    return ajaxFetcher({
        method: 'POST',
        url: url,
        queryParams: queryParams,
        contentType: contentType,
        data: data
    });
};
